import React from 'react';

const ButtonFlatWarning = ({ children, size = 'md', ghost = false, onClick = () => {}, disabled = false }) => (
    <button
        className={`appButton__flat appButton__flat--warning${ghost ? ' appButton__flat--warning--ghost' : ''} ${size}`}
        disabled={disabled}
        onClick={onClick}>
        {children}
    </button>
);

export default ButtonFlatWarning;
